export const SearchKeys = {
  all: ["search"] as const,
};
